import type {PageContent} from '@gravity-ui/page-constructor';

import {isObject} from '~shared/utils';

import type {PromoPageListItemProps} from '../../PromoPageListItem';

export const getAnchors = (content: PageContent) => {
    const anchors: PromoPageListItemProps[] = [];
    for (const block of content.blocks) {
        if ('anchor' in block && isObject(block.anchor)) {
            anchors.push({text: block.anchor.text as string, href: `#${block.anchor.url}`});
        }
    }
    return anchors;
};
